import api from "./api";

export const pointOfSaleService = {
  list() {
    return api.get("/points-of-sale");
  },
  get(id) {
    return api.get(`/points-of-sale/${id}`);
  },
  create(payload) {
    return api.post("/points-of-sale", payload);
  },
  update(id, payload) {
    return api.patch(`/points-of-sale/${id}`, payload);
  },
  remove(id) {
    return api.delete(`/points-of-sale/${id}`);
  },
};
